'use client';

import React, {
  forwardRef,
} from 'react';

import Item, { type ItemProps } from './Item';
import useTranslation from '../translation/useTranslation';

interface LoginProps extends Partial<ItemProps> {}

function Login(
  {
    title = '',
    icon = <i aria-hidden>login</i>,
    ...props
  }: LoginProps,
  ref: LoginProps['ref'],
) {
  const { t } = useTranslation();

  return (
    <Item
      title={title || t('login.text')}
      icon={icon}
      hideTextOnMobile={false}
      {...props}
      ref={ref}
    />
  );
}

export default forwardRef(Login);
